import React from 'react';
import './RegistrationGuide.scss';

const RegistrationGuide = () => (
    <div className="registration-guide">
        <h2>Registration User Guide – How to Register</h2>

        <div className="guide-section">
            <h3>1. Sign up for ICON</h3>
            <p>Visit <a href="https://iconportal.com/" target="_blank" rel="noopener noreferrer">iconportal.com</a></p>
            <ul>
                <li>Easy and intuitive registration process</li>
                <li>Fast approval and access to ICON</li>
                <li>Register your Organization, register yourself as an Industry User or register as a Government User</li>
            </ul>
        </div>

        <div className="guide-section">
            <h3>2. Obtain a Valid Cage Code</h3>
            <p>Visit <a href="https://sam.gov" target="_blank" rel="noopener noreferrer">SAM.gov</a></p>
            <ul>
                <li>You Do Not Need a CAGE code to access ICON</li>
                <li>You Do Need a CAGE code to receive DoD awards</li>
                <li>ICON pulls CAGE information directly from SAM.gov to populate and verify accounts</li>
            </ul>
        </div>

        <div className="guide-section">
            <h3>3. Register in DIBBS</h3>
            <p>Visit <a href="https://www.dibbs.bsm.dla.mil" target="_blank" rel="noopener noreferrer">DLA Internet Bid Board System (DIBBS)</a></p>
            <ul>
                <li>Bid on DLA contracting opportunities identified and researched in ICON</li>
                <li>Review Technical Data Packages (blueprints) - <a href="https://www.dla.mil/Information-Operations/Offers/Products/Technical-Data-Packages/" target="_blank" rel="noopener noreferrer">DLA PDMI</a></li>
            </ul>
        </div>

        <div className="guide-section">
            <h3>4. Joint Certificate Program (JCP) Certification</h3>
            <p>Visit <a href="https://www.dla.mil/Information-Operations/Offers/Products/JCP/" target="_blank" rel="noopener noreferrer">JCP Home</a></p>
            <ul>
                <li>Certification permits users to open and review Technical Data Packages</li>
            </ul>
        </div>
    </div>
);

export default RegistrationGuide; 


// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/RegistrationGuide.jsx